const prefetchedUrls = new Set<string>();

const prefetchJson = (url: string) => {
  if (prefetchedUrls.has(url)) return;
  prefetchedUrls.add(url);

  fetch(url, { cache: 'force-cache' }).catch(() => {
    prefetchedUrls.delete(url);
  });
};

export const prefetchGeoKnowledgeArticle = (id?: string) => {
  if (!id) return;
  prefetchJson(`/article-data/knowledge/${id}.json`);
};

export const prefetchGeoNewsArticle = (category?: string, id?: string) => {
  if (!category || !id) return;
  prefetchJson(`/article-data/news/${category}/${id}.json`);
};
